import { render } from "./HelpMenu.vue?vue&type=template&id=4ad661b3&scoped=true"
import script from "./HelpMenu.vue?vue&type=script&lang=js"
export * from "./HelpMenu.vue?vue&type=script&lang=js"

import "./HelpMenu.vue?vue&type=style&index=0&id=4ad661b3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad661b3"]])

export default __exports__